export const PubNetworkApiColumns = {
    DOMAIN_ID: 'domain.id',
    DOMAIN_NAME: 'domain.name',

    IMPRESSIONS: 'impressions',
    PAID_CLICKS: 'paid_clicks',
    PAID_CTR: 'paid_ctr_decimal',
    REVENUE: 'revenue',
}
